import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss']
})
export class PaymentSummaryComponent implements OnInit, OnChanges {
  totalFees: number = 20000;
  discountAmount: number = 0;
  totalAmount: number = 20000;
  couponApplied = '';
  isCouponApplied: boolean = false;
  invalidCouponCode: boolean = false;
  discountAvailable: boolean = true;
  @Output() couponData = new EventEmitter();
  @Input() appliedCouponDetails;
  @Input() atPaymentPage;
  receiveDiscount: any;
  appliedCouponId: any;
  isCouponDisable = false;

  constructor(private authService: AuthService) {

  }

  ngOnInit(): void {
    console.log('atPaymentPage', this.atPaymentPage);
    this.authService.getCouponDiscountAmount().subscribe((responseAmount: any) => {
      this.receiveDiscount = responseAmount;
      this.calculateDiscount(this.receiveDiscount);
      console.log(this.receiveDiscount);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);

    if (changes?.appliedCouponDetails?.currentValue !== undefined) {
      if (changes?.appliedCouponDetails?.currentValue?.coupon !== null) {
        this.couponApplied = changes?.appliedCouponDetails?.currentValue?.coupon?.code;
        this.discountAmount = changes?.appliedCouponDetails?.currentValue?.coupon?.discount;
        this.authService.setCouponDiscountAmount(this.discountAmount);
        this.isCouponApplied = true;
      }
      this.isCouponDisable = changes?.appliedCouponDetails?.currentValue?.is_any_payment_approved ? true : false;
    }
  }

  removeCouponClick() {
    this.couponApplied = '';
    this.discountAmount = 0;
    this.calculateDiscount(0);
    this.isCouponApplied = false;
    this.authService.setCouponDiscountAmount(0);
    this.couponData.emit({ couponId: 'empty', couponDiscount: 0 });          //Empty to reset/empty the current applied coupon
  }

  changeCoupon(event) {
    console.log(event, event.target.value);
    if (event.target.value == '') {
      this.calculateDiscount(0);
      this.authService.setCouponDiscountAmount(0);
      this.couponData.emit({ couponId: 'empty', couponDiscount: 0 });          //Empty to reset/empty the current applied coupon
      this.isCouponApplied = false;
    } else {
      let coupon = event.target.value;
      let payload = { 'couponCode': coupon, 'amount': this.totalFees, user_id: +sessionStorage.getItem('userId') }
      this.authService.getCouponDiscount(payload).subscribe((response: any) => {
        // console.log(response);
        this.discountAmount = response?.data?.discount;
        this.authService.setCouponDiscountAmount(this.discountAmount);
        this.couponData.emit({ couponId: response?.data?.id, couponDiscount: response?.data?.discount });
        this.appliedCouponId = response?.data?.id;
        this.calculateDiscount(this.discountAmount)
        this.isCouponApplied = true;
        Swal.fire('Success', 'Congrats! Coupon applied successfully', 'success')
      },
        (error) => {
          Swal.fire('Error', `${error.error.message}`, 'error')
        })
    }
  }

  calculateDiscount(discountAmount) {
    // let couponObj = { couponData: this.appliedCouponId, total_discounted_amount: this.totalAmount }
    // this.authService.setcouponDetails(couponObj);

    this.discountAmount = discountAmount;
    this.totalAmount = this.totalFees - discountAmount;
  }
}

